import script from "./TablaAlumnos.vue?vue&type=script&setup=true&lang=js"
export * from "./TablaAlumnos.vue?vue&type=script&setup=true&lang=js"

import "./TablaAlumnos.vue?vue&type=style&index=0&id=6936aba2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6936aba2"]])

export default __exports__